import React, { Component } from "react";
import i18n from "i18next";
import PropTypes from "prop-types";

export default class SoundListProvider extends Component {
  constructor(props) {
    super(props);
    this.audio = new Audio();
    this.interval = null;
    this.state = {
      playingIndex: -1,
      currentTime: 0,
      audioDuration: 0,
    };
    this.togglePlay = this.togglePlay.bind(this);
    this.stopPlayback = this.stopPlayback.bind(this);
  }

  componentWillUnmount() {
    this.audio.pause();
    if (this.interval) clearInterval(this.interval);
  }

  stopPlayback() {
    this.audio.pause();
    this.audio.currentTime = 0;
    if (this.interval) clearInterval(this.interval);
    this.interval = null;
    this.setState({ playingIndex: -1, currentTime: 0, audioDuration: 0 });
  }

  togglePlay(index, sound) {
    if (this.state.playingIndex === index) {
      this.audio.pause();
      if (this.interval) clearInterval(this.interval);
      this.setState({ playingIndex: -1 });
      return;
    }

    this.audio.pause();
    if (this.interval) clearInterval(this.interval);
    this.audio.src = sound.file;
    this.audio.currentTime = 0;
    this.audio.play().catch(() => {});
    this.setState({ playingIndex: index, currentTime: 0, audioDuration: 0 });

    this.interval = setInterval(() => {
      const ct = this.audio.currentTime || 0;
      const dur = isNaN(this.audio.duration) ? 0 : this.audio.duration;
      this.setState({ currentTime: ct, audioDuration: dur });
      if (this.audio.ended) {
        clearInterval(this.interval);
        this.setState({ playingIndex: -1, currentTime: 0 });
      }
    }, 200);
  }

  formatTime(seconds) {
    const s = Math.round(seconds);
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  }

  render() {
    const { soundList, hide, setAddSoundVisibleWithIndex, deleteSound } = this.props;
    const { playingIndex, currentTime, audioDuration } = this.state;

    return (
      <div className="soundList" style={{ display: hide ? "none" : "block" }}>
        {soundList
          ? soundList.map((sound, index) => {
              const isPlaying = playingIndex === index;
              const ct = isPlaying ? currentTime : 0;
              const dur =
                isPlaying && audioDuration > 0
                  ? audioDuration
                  : sound.endTime - sound.startTime || 0;
              const progress = dur > 0 ? Math.min((ct / dur) * 100, 100) : 0;
              const remaining = Math.max(0, dur - ct);

              return (
                <div key={index} className={"soundListItem" + (isPlaying ? " playing" : "")}>
                  <div className="soundListItem__name" title={sound.name}>
                    {sound.name}
                  </div>

                  <div className="soundListItem__player">
                    <button
                      type="button"
                      className="soundListItem__play"
                      aria-label={isPlaying ? i18n.t("Sound.Pause") : i18n.t("Sound.Play")}
                      onClick={() => this.togglePlay(index, sound)}
                    >
                      <i className="material-icons">{isPlaying ? "pause" : "play_arrow"}</i>
                    </button>
                    <span className="soundListItem__time">{this.formatTime(ct)}</span>
                    <div className="soundListItem__track">
                      <div className="soundListItem__fill" style={{ width: `${progress}%` }} />
                    </div>
                    <span className="soundListItem__time soundListItem__time--muted">
                      -{this.formatTime(remaining)}
                    </span>
                  </div>

                  <div className="soundListItem__footer">
                    <span className="soundListItem__meta">
                      {i18n.t("Sound.Start_Time") + sound.startTime + " - " + sound.endTime}
                    </span>
                    <div className="soundListItem__actions">
                      <button
                        type="button"
                        className="soundListItem__action"
                        aria-label={i18n.t("Sound.Edit")}
                        title={i18n.t("Sound.Edit")}
                        onClick={() => setAddSoundVisibleWithIndex(index)}
                      >
                        <i className="material-icons">edit</i>
                      </button>
                      <button
                        type="button"
                        className="soundListItem__action soundListItem__action--danger"
                        aria-label={i18n.t("Sound.Delete")}
                        title={i18n.t("Sound.Delete")}
                        onClick={() => {
                          this.stopPlayback();
                          deleteSound(index);
                        }}
                      >
                        <i className="material-icons">delete</i>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    );
  }
}

SoundListProvider.propTypes = {
  formControlProps: PropTypes.object,
  id: PropTypes.any,
  hide: PropTypes.bool,
  soundList: PropTypes.array,
  deleteSound: PropTypes.func,
  setAddSoundVisibleWithIndex: PropTypes.func,
};
